/* eslint-disable */
import React, { useState, useRef } from "react";
import { Pagination } from "../Pagination";
import {FaSearch, FaRegCalendarAlt  } from "react-icons/fa";
import LeadsApi from "./LeadsApi";
import { DateRangePicker } from 'react-date-range';
import { format } from 'date-fns';
import { enUS } from 'date-fns/locale';
import { Badge } from 'reactstrap';
import { CSVLink, CSVDownload } from "react-csv";


export default function Leads() {
  const pageSize = 10; 
  const [currentPage, setCurrentPage] = useState(1); 
  const [searchQuery, setSearchQuery] = useState("");
  const [showModal, setshowModal] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("All Email");
  const [selectStatus, setSelectStatus] = useState("Select Emails Status");
  const [emailType, setEmailType] = useState("Select Email Type")
  const [totalData, setTotalData] = useState(0)
  const [exportData, setExportData] = useState([])
  const closeModal = () => setshowModal(false);
  const handlePrevPage = () => {
    setCurrentPage((prevPage) => prevPage - 1);
  };

  const handleNextPage = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };

  const renderPageNumbers = () => {
    // Calculate the range of page numbers to display
    const startPage = Math.max(1, currentPage - 2);
    const endPage = Math.min(Math.ceil(totalData / pageSize), currentPage + 2);

    const pageNumbers = [];
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <li
          key={i}
          className={`page-item ${i === currentPage ? "active" : ""}`}
          onClick={() => setCurrentPage(i)}
        >
          <span className="page-link">{i}</span>
        </li>
      );
    }

    return pageNumbers;
  };

  // const updateTotalItems = (length) => {
  //   setTotalItems(length);
  // };

  const [showCalendar, setShowCalendar] = useState(false);
  const [value, setValue] = useState({ startDate: "", endDate: "" });
  const formattedStart = value.startDate ? format(new Date(value.startDate), "dd/MM/yyyy") : "Select Date Range";
  const formattedEnd = value.endDate ? format(new Date(value.endDate), "dd/MM/yyyy") : "";
  const [data, setData] = useState();

  const ref = useRef();

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setShowCalendar(false);
    }
  };
const getCsvFileName = () => {
  const now = new Date();
  const formattedDate = now
    .toISOString()
    .replace(/T/, '_')
    .replace(/:/g, '-')
    .replace(/\..+/, '');

  return `Lead_Data_${formattedDate}.csv`;
};
const excludedKeys = ["set_data_and_html_client", "set_data_and_html"];

const headers = exportData.length > 0
  ? Object.keys(exportData[0])
      .filter(key => !excludedKeys.includes(key))
      .map(key => ({
        label: key,
        key: key
      }))
  : [];

  const handleUpdate = () =>{
    setData(value);
    setShowCalendar(false)
  }

  React.useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div>
      <section className="dash-section">
        <div className="container-fluid p-0">
          <div className="row p-0 m-0">
            <div className="col-lg-12 col-md-12 col-sm-12 right-content">
              <div className="head-name">
                <h3>Leads</h3>
              </div>

              <div className="data-content">
                <div className="top-button">
                  <div className="all-drop">
                <div className="dropdown">
                    <button
                      className="btn btn-secondary dropdown-toggle email-filter"
                      type="button"
                      id="dropdownMenuButton"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      {selectedCategory || "Select Email Category"}
                    </button>
                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <li onClick={() => setSelectedCategory("All Email")}>
                          All Email
                      </li>
                      <li onClick={() => setSelectedCategory("Ham Emails")}>
                          Ham Emails
                      </li>
                      <li onClick={() => setSelectedCategory("Spam Emails")}>
                          Spam Emails
                      </li>
                    </ul>
                    
                  </div>
                <div className="dropdown">
                    <button
                      className="btn btn-secondary dropdown-toggle status-filter"
                      type="button"
                      id="dropdownMenuButton"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      {selectStatus || "All Mail"}
                    </button>
                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <li onClick={() => setSelectStatus("Select Emails Status")}>
                    Select Emails Status
                      </li>
                      <li onClick={() => setSelectStatus("Pending")}>
                          Pending
                      </li>
                      <li onClick={() => setSelectStatus("Send")}>
                         Send
                      </li>
                     
                    </ul>

                  </div>
                  <div className="dropdown">
                    <button
                      className="btn btn-secondary dropdown-toggle type-filter"
                      type="button"
                      id="dropdownMenuButton"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      {emailType || "All Email Type"}
                    </button>
                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <li onClick={() => setEmailType("Select Email Type")}>
                    Select Email Type
                      </li>
                      <li onClick={() => setEmailType("Subscribe")}>
                      Subscribe
                      </li>
                      <li onClick={() => setEmailType("Callback")}>
                      Callback
                      </li>
                      <li onClick={() => setEmailType("Demo")}>
                      Demo
                      </li>
                      <li onClick={() => setEmailType("Ebook")}>
                      Ebook
                      </li>
                      <li onClick={() => setEmailType("Free Trail Demo")}>
                      Free Trail Demo
                      </li>
                      <li onClick={() => setEmailType("Casestudy")}>
                      Casestudy
                      </li>
                      <li onClick={() => setEmailType("Career")}>
                      Career
                      </li>
                      <li onClick={() => setEmailType("webinar")}>
                      Webinar
                      </li>
                      <li onClick={() => setEmailType("blog")}>
                      Blog Lead
                      </li>
                     
                    </ul>

                  </div>
   <div style={{ position: "relative", display: "inline-block" }}>
      {/* Trigger */}
      <div
        className="date-filter"
        onClick={() => setShowCalendar(!showCalendar)}
        style={{
          display: "flex",
          alignItems: "center",
          padding: "8px 12px",
          border: "1px solid #ccc",
          borderRadius: "4px",
          cursor: "pointer",
          color: "#fff",
          backgroundColor: "var(--primary-color)",
        }}
      >
        <input
          type="text"
          className="date-input"
          readOnly
           value={
         value.startDate && value.endDate
      ? `${formattedStart} - ${formattedEnd}`
      : "" 
  }
   placeholder="Select date range"
          style={{
            border: "none",
            outline: "none",
            fontSize: "16px",
            backgroundColor: "transparent",
            cursor: "pointer",
            color: "#fff",
          }}
        />
        <FaRegCalendarAlt style={{ fontSize: "18px", color: "#fff" }} />
      </div>

      {/* Calendar */}
      {showCalendar && (
        <div
          style={{
            position: "absolute",
            zIndex: 10,
            background: "#fff",
            padding: "12px",
            borderRadius: "6px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
            marginTop: "4px",
          }}
        >
          <div className="range-selection">
            <div>
              <label htmlFor="range-start" className="text-sm font-medium">
                Start Date & Time
              </label>
              <input
                id="range-start"
                type="date"
                value={value.start}
                onChange={(e) => setValue({ ...value, startDate: e.target.value })}
              />
            </div>

            <div>
              <label htmlFor="range-end" className="text-sm font-medium">
                End Date & Time
              </label>
              <input
                id="range-end"
                type="date"
                value={value.end}
                onChange={(e) => setValue({ ...value, endDate: e.target.value })}
              />
            </div>

            <div className="range-buttons">
              <button
                type="button"
                onClick={() => setValue({ start: "", end: "" })}
                style={{
                  padding: "6px 20px",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  background: "#f5f5f5",
                  cursor: "pointer",
                }}
              >
                Clear
              </button>
              <button
                type="button"
                onClick={handleUpdate}
                style={{
                  padding: "6px 20px",
                  border: "none",
                  borderRadius: "4px",
                  background: "var(--primary-color)",
                  color: "#fff",
                  cursor: "pointer",
                }}
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
                  </div> 
                  <div className="searchBox">
                    <input
                      className="searchText"
                      type="text"
                      placeholder="Type to Search..."
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                    <div className="searchBtn search-button" disabled>
                      <FaSearch />
                    </div>
                  </div>
                </div>
                <div  style={{display:"flex", alignItems:"center", justifyContent:"flex-end"}}>
                  <div className="export-data"style={{  color: "#fff", fontSize: "0.9rem", marginBottom: "10px", backgroundColor: "#198754", padding: "12px 20px", 
                      borderRadius: "50px", border: "none", marginRight: "10px", fontSize: "15px", fontWeight: 600, textDecoration: "none" }}>
                    <CSVLink
                     data={exportData}
                     headers={headers}
                     filename={getCsvFileName()}
                     style={{color: "#fff", textDecoration: "none" }}>
                     Export Data
                     </CSVLink>
                  </div>
                   <Badge color="primary" style={{  color: "#fff", fontSize: "0.9rem", marginBottom: "10px", backgroundColor: "#530cb3" }}
                       className="custom-bage d-inline-flex align-items-center px-3 py-3 rounded-pill total-lead"
                                    >
                                      Total Leads: {totalData}
                                    </Badge>
                </div>
                <table className="table table-striped table-hover blog-table table-data">
                  <thead className="thead-dark">
                    <tr>
                    <th scope="col" width="3%">
                      View
                      </th> 
                      <th scope="col" width="3%">
                      Resume
                      </th>
                      {/* <th scope="col" width="3%">
                      Spam/Ham
                      </th> */}
                      <th scope="col" width="10%">
                        Name
                      </th>
                      <th scope="col" width="10%">
                      Category
                      </th>
                      <th scope="col" width="12%">
                      Email
                      </th>
                      <th scope="col" width="12%">
                        Phone No.
                      </th>
                      {/* <th scope="col" width="15%">
                       Subject
                      </th> */}
                      <th scope="col" width="15%">
                      Date
                      </th>
                      
                      <th scope="col" width="8%">
                        Status
                      </th>
                         
                      <th scope="col" width="15%">
                       Action
                      </th>
                    </tr>
                  </thead>
                  <LeadsApi
                    page={currentPage}
                    selectedCategory={selectedCategory}
                    dateRange = {data}
                    selectStatus = {selectStatus}
                    emailType={emailType}
                    pageSize={pageSize}
                    searchQuery={searchQuery}
                    // totalLength={setTotalData}
                    setTotalData= {setTotalData}
                    setExportData = {setExportData}                   
                  />
                </table>
                <Pagination
                  currentPage={currentPage}
                   setCurrentPage = {setCurrentPage}
                  totalItems={totalData}
                  pageSize={pageSize}
                  onPrevPage={handlePrevPage}
                  onNextPage={handleNextPage}
                  renderPageNumbers={renderPageNumbers}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
